import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getProductApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code || data?.error?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED' || code === 'UPDATED_AT_INVALID') {
    return data?.message || '更新時間無效，請重新載入後再試';
  }

  if (code === 'CRM_PRODUCT_NO_ALREADY_EXISTS') {
    return data?.message || '產品代號已存在';
  }

  if (code === 'CRM_PRODUCT_MATERIAL_INACTIVE') {
    return data?.message || '產品物料必須是啟用狀態';
  }

  if (code === 'CRM_PRODUCT_MATERIAL_KIND_INVALID') {
    return data?.message || '產品物料必須是一般料';
  }

  if (code === 'CRM_PRODUCT_MATERIAL_STRUCT_MAIN_INVALID') {
    return data?.message || '產品物料主分類必須是 A';
  }

  if (code === 'CRM_PRODUCT_IN_USE') {
    return data?.message || '產品仍被未結案的單據使用，無法停用';
  }

  if (code === 'CRM_PRODUCT_CUSTOMER_INACTIVE') {
    return data?.message || '綁定客戶必須是啟用狀態';
  }

  return data?.message || fallback;
}

export function isProductVersionConflict(error) {
  const data = error?.response?.data;
  return (data?.code || data?.error?.code) === 'RESOURCE_VERSION_CONFLICT';
}

export const PRODUCT_IN_USE_DOCUMENT_TYPE_LABELS = {
  CUSTOMER_ORDER: '客戶訂單',
  SALES_ORDER: '銷貨單',
};

/**
 * 409 `CRM_PRODUCT_IN_USE` 的阻擋單據（`details` 最多 20 筆，另附總數與未列出筆數）。
 * 其他錯誤回 null。
 *
 * @returns {{
 *   totalCount: number,
 *   omittedCount: number,
 *   documents: Array<{ documentType: string, documentNo: string, id: string }>,
 * }|null}
 */
export function getProductInUseDetails(error) {
  const data = error?.response?.data;
  if ((data?.code || data?.error?.code) !== 'CRM_PRODUCT_IN_USE') {
    return null;
  }
  const details = data?.details ?? {};
  const documents = (Array.isArray(details.documents) ? details.documents : []).map((doc) => ({
    documentType: doc?.document_type ?? doc?.documentType ?? '',
    documentNo: doc?.document_no ?? doc?.documentNo ?? '',
    id: doc?.id ?? '',
  }));
  return {
    totalCount: Number(details.total_count ?? details.totalCount ?? documents.length) || documents.length,
    omittedCount: Number(details.omitted_count ?? details.omittedCount ?? 0) || 0,
    documents,
  };
}
